import React from "react";
import Layout from './Layout';
import { Mailing } from "../../components/User/Mailing";

export const MailingPage = () => <Layout><Mailing></Mailing></Layout>
